module.exports = __webpack_public_path__ + "static/media/Portfolio.7dcf3dd8.png";